import { StockItem } from '../../common/types/StockItemTypes';
import { getAutoOpenState } from '../Search/components/modal/VideoEditorModal/utils/stateUtils';
import { OptInNames } from '../Shared/enums';
import { TaskStatus } from './ContentEditSlice';

export interface ContentEditState {
  isPolling: boolean;
  isOpen: boolean;
  selectedStockItem?: StockItem;
  modalState: 'edit' | 'loading' | 'result';
  status: TaskStatus | null;
  outputUrl?: string;
  taskId?: string;
  error?: string;
  creditBalance: number;
  isSpendingCredits: boolean;
  spendCreditsError: string | null;
  stockItemEdited?: StockItem;
  jobId?: number;
  purchaseInfo?: any;
  purchaseInfoError?: string | null;
  isFetchingPurchaseInfo?: boolean;
  optIns: Partial<Record<OptInNames, boolean>>;
}

class ContentEditStateDefinition {
  static getInitialState(): ContentEditState {
    // Get auto-open state and stored data in a single operation
    const { shouldOpen, storedState } = getAutoOpenState();

    return {
      isOpen: shouldOpen && !!storedState?.stockItem,
      isPolling: false,
      selectedStockItem: shouldOpen ? storedState?.stockItem || null : null,
      modalState: 'edit',
      status: null,
      creditBalance: 0,
      isSpendingCredits: false,
      spendCreditsError: null,
      optIns: {},
    };
  }
}

export default ContentEditStateDefinition;
